import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { SnackbarService } from '../services/snackbarService/snackbar.service';

@Injectable()
export class VectronicErrorHandler implements ErrorHandler {
  private snackbarService = inject(SnackbarService);
  private zone = inject(NgZone);

  handleError(error: Error) {
    let msg: string;
    if (error instanceof HttpErrorResponse && (error as HttpErrorResponse).status >= 400) {
      if (typeof error.error === 'string') {
        msg = error.error;
      } else {
        msg = 'message' in error.error ? error.error.message : JSON.stringify(error.error, null, 2);
      }
      this.zone.run(() => {
        this.snackbarService.openSnackBar(msg, {
          duration: 5000,
          verticalPosition: 'top',
        });
      });
    }
    console.error(error);
  }
}
